<div id="app_container" class="{{getBackground()}}">
  <div class='headerbck'>

    <div class='main-header-container'>
      <nav id="header" class="app-component navbar navbar-inner">
        @if (!isMainPage) {
          <nav class="seheader">
            <div class="navbar-header">
              <button type="button"
                class="app-component navbar-toggle" [class.collapsed]="!isMenuExpanded" [attr.aria-expanded]="isMenuExpanded" (click)="openMenu($event)"
                style="float: left;">
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
              </button>
              <a class="app-component navbar-brand" routerLink="/">
                <img src="/images/logo-white2.png" alt="logo">
              </a>
            </div>
            @if (!isMainPage) {
              <div class="app-component navbar-collapse menuItemsContainer" [class.menu-expanded]="isMenuExpanded">
                @if (!isMainPage) {
                  <ul class="app-component nav navbar-nav nav-pills navBarPadding main-nav">
                    <li routerLinkActive="active"><a routerLink="/wybierz-design" (click)="collapseMenu()">Wybierz&nbsp;design</a></li>
                    <li routerLinkActive="active">
                      <a routerLink="/szybka-konfiguracja" (click)="collapseMenu()">
                        Szybka&nbsp;konfiguracja
                      </a>
                    </li>
                  </ul>
                }
                @if (!isUserLoggedIn) {
                  <ul class="app-component nav navbar-nav nav-pills navBarPadding navbar-right login-link auth-nav">
                    <li><a class="auth-link auth-login" routerLink="/logowanie" (click)="collapseMenu()">Zaloguj</a></li>
                  </ul>
                }
                @if (isUserLoggedIn) {
                  <ul class="app-component nav navbar-nav nav-pills navBarPadding navbar-right auth-nav">
                    @if (false) {
                      <li routerLinkActive="active">
                        <a href="/moje-konto">Konto</a>
                      </li>
                    }
                    <li (click)="collapseMenu(); logout()"><a class="auth-link auth-logout" href="javascript:;">Wyloguj</a></li>
                  </ul>
                }
              </div>
            }
          </nav>
        }
        @if (isMainPage) {
          <nav class="seheader">
            <div class="navbar-header">
              <a class="app-component navbar-brand" routerLink="/">
                <img src="/images/logo-white2.png" alt="logo">
              </a>
              <button type="button"
                class="app-component navbar-toggle" [class.collapsed]="!isMenuExpanded" [attr.aria-expanded]="isMenuExpanded" (click)="openMenu($event)"
                style="float: left;">
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
              </button>
            </div>
            <div class="app-component navbar-collapse menuItemsContainer" [class.menu-expanded]="isMenuExpanded" style="top: -14px;right: 40px;">
              <div style="display: flex;">
                <div class="sedna_design_bar sednadesign">
                  <!--<img src="/images/main/sednadesign.png" />-->
                  <a href="/sednadesign">
                    <span class="glyphicon glyphicon-none">
                    </span><img src="/images/main/sednadesign.png" alt="Sedna Design & Elegance" />
                  </a>
                </div>
                <!--<ul class="app-component nav navbar-nav nav-pills navBarPadding navbar-right button-border sednadesign">
                <li><a href="/sednadesign/"><span class="glyphicon glyphicon-none">
                </span><img src="/images/main/sednadesign.png" alt="Sedna Design & Elegance" /> </a></li>
              </ul>
              -->
            </div>
          </div>
          <div class="app-component navbar-collapse menuItemsContainer main-page-auth-menu" [class.menu-expanded]="isMenuExpanded">
            @if (!isUserLoggedIn) {
              <ul class="app-component nav navbar-nav nav-pills navBarPadding navbar-right auth-nav">
                <li><a class="auth-link auth-login" routerLink="/logowanie">Zaloguj</a></li>
              </ul>
            }
            @if (isUserLoggedIn) {
              <ul class="app-component nav navbar-nav nav-pills navBarPadding navbar-right auth-nav">
                @if (false) {
                  <li routerLinkActive="active">
                    <a href="/moje-konto">Konto</a>
                  </li>
                }
                <li (click)="logout()"><a class="auth-link auth-logout" href="javascript:;">Wyloguj</a></li>
              </ul>
            }
          </div>
        </nav>
      }
    </nav>
  </div>
</div>
<div class="maincontentcontainer">
  @if (!removePrebootScreen) {
    <div id="pre-bootstrap" [class.prebootShow.app-component]="!isAppLoaded" class="app-component prebootStep">
      <div class="messaging">
        <h1>
          Loaded!
        </h1>
        <p>
          SCHNEIDER_ELECTRIC - <span class="appName" style="font-style:italic">Twój</span><span class="appName">konfigurator</span>
        </p>
      </div>
    </div>
  }

  <router-outlet></router-outlet>



</div>



@if (shouldShowLoginModal) {
  <div class="modal fade" bsModal #loginModal="bs-modal" (onShown)="onLoginModalShown()" (onHidden)="onLoginModalHidden()" (onHide)="onLoginModalHide()"
    [config]="{backdrop: 'static'}" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <app-login #loginControl isModal="true"></app-login>
    </div>
  </div>
}
</div>

<!--footer-->
@if (isMainPage || isSePage || isRegisterPage) {
  <div class="row">
    <div id="footer">
      <div class="app-component navbar-bottom navbar-inner footer">
        <footer>
          <div class="app-component vright_text center-block">
            @if (authService.isLoggedIn) {
              <div class="footer-function" (click)="removeAccountDialog()">Usuń konto</div>
            }
            <p class="text-center text-muted footer-text">
              @if (isSePage) {
                <a target="_blank" href="/documents/Common/Zasady korzystania ze zniżek pracowniczych.pdf">Zasady korzystania ze zniżek pracowniczych</a>
              }
              @if (isSePage) {
                <span class="footer-text">|</span>
              }
              <a target="_blank" href="https://www.se.com/pl/pl/about-us/legal/data-privacy.jsp">Polityka prywatności</a>
              <span class="footer-text">|</span>
              <a target="_blank" href="https://www.schneider-electric.pl" target="_blank">© Schneider Electric Polska.</a>
            </p>
          </div>
        </footer>
      </div>
    </div>
  </div>
}

<div id="waitingoverlay" hidden>
  <mat-progress-spinner></mat-progress-spinner>
</div>

<app-cookie-banner></app-cookie-banner>
